import styled from "styled-components";

export const MonthSettlementClosingCalenderWrapper = styled.div`
  margin-top: 30px;
`;

export const MonthSettlementClosingCalenderHeader = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;

  > .title {
    align-items: center;
    display: flex;
    gap: 8px;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 18px;
  }
`;

export const MonthSettlementClosingCalenderCircle = styled.div<{
  isPurple?: boolean;
  size?: string;
}>`
  width: ${(p) => (p.size ? p.size : "14px")};
  height: ${(p) => (p.size ? p.size : "14px")};
  background: ${(p) => (p.isPurple ? "#7F25FB" : "#FF0000")};
  border-radius: 50%;
`;

export const MonthSettlementClosingCalenderGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-family: Pretendard;
  font-weight: 600;

  > .label {
    background: #ecf0f3;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }

  > .empty {
    border-bottom: 1px solid #ecf0f3;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
  }
`;

export const MonthSettlementClosingCalenderDay = styled.div`
  width: 151px;
  height: 103px;
  box-sizing: border-box;
  border-bottom: 1px solid #ecf0f3;
  border-left: 1px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 13px;
  gap: 20px;
  cursor: pointer;
  position: relative;

  > .day {
    font-weight: 600;
    font-size: 21px;
    text-align: left;
  }

  > .wrapper {
    display: flex;
    flex-direction: column;
    gap: 7px;

    > .text {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 500;
      font-size: 12px;
      text-align: right;
    }
  }
`;
